<template>
    <b-col 
        class="sag-form-text-box" 
        sm="12"
    >
        <b-form-group
            :id="'lab_' + id"
            :description="description"
            :label="label"
            :label-for="id"
            valid-feedback="Thank you!"
        >
            <b-form-input 
                type="number"
                v-model="regSagNum"
                v-bind="$attrs"
                lazy
                :id="id" trim
            ></b-form-input>
        </b-form-group>
    </b-col>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { BFormInput, BCol, BFormGroup } from 'bootstrap-vue'

export default {
    components:{
        BFormInput,
        BCol,
        BFormGroup
    },  
    props: {
        label: {
            type: String,
            default: 'Default'
        },
        id: {
            type: String,
            required: true
        },
        description: {
            type: String,
            default: ''
        },
        sagValue: {
            type: Number,
            default: 0
        }

    },
    setup(props, { emit }) {
        const regSagNum = ref(props.sagValue)

        watch(regSagNum, (newValue, oldValue)=>{
            // console.log('watch regSagNum newValue type is', typeof(newValue))
            // console.log('watch regSagNum newValue converto int is', parseInt(newValue))
            emit('sagChangeEvent', {
                name: props.id,
                value: parseInt(newValue)
            })
        })

        emit('sagRefreshData', {
            key: props.id,
            value: (newValue)=>{
                regSagNum.value = newValue
            }
        })

        return {
            regSagNum
        }
    },
}
</script>
